package main.kotlin.ui

import main.kotlin.data.BlurbType
import org.w3c.dom.Document

class SectionHeaderTypeSelector(document: Document, id:String, hint:String) : BlurbTypeSelector(document,id,hint,arrayOf(BlurbType.Text,BlurbType.Info,BlurbType.InfoUser,BlurbType.Note,BlurbType.Caution,BlurbType.Warning))
